import { IFileScan } from './file-scan';

export interface ICaseDocument {
  id: number;
  creationDate: Date;
  documentId: string;
  documentType: string;
  documentName: string;
  documentStatus: string;
  documentExtension: string;
  outgoing: boolean;
  sender: string;
  recipient: string;
  caseDocumentTags: ICaseDocumentTag[];
  comments: string;
  unhandled: boolean;
  deleted: boolean;
  deletedBy: string;
  stakeholderSenderId: number;
  stakeholderReceiverId: number;
  fileScan: IFileScan;
}

export interface ICaseDocumentTag {
  name: string;
}

export enum CaseDocumentEnum {
  MEDICAL_INFO = 'Medical info',
  CLAIM_FORM = 'Claim form',
  GOP_VOB = 'GOP / VOB',
  GOP_VOB_CANCEL = 'GOP / VOB cancelled',
  SUPPLIER_INVOICE = 'Supplier invoice',
  CUSTOMER_INVOICE = 'Customer invoice',
  MEDICAL_ESCORT_INVOICE = 'Medical escort invoice',
  MEDIF = 'Medif',
  CONSENT = 'Consent',
  TRAVEL_INFO = 'Travel info',
  ESCORT_TRAVEL_EXPENSES = 'Escort travel expenses',
  PASSPORT_AND_ID = 'Passport and ID'
}
